import React from "react";
import { useTranslation } from "react-i18next";
import { Dialog, DialogActions, DialogDescription, DialogTitle } from "src/components/base/dialog";
import { Button } from "src/components/base/button";
import { toast } from "react-toastify";
import { ApiInternal } from "src/api/api_internal";
import { FullDevice } from "src/api/generated/frontend_internal_v1";

/**
 * The properties for {@link ExpireDeviceKeyDialog}
 */
export type ExpireDeviceKeyDialogProps = {
    /** Callback for closing the popup */
    onClose: () => void;

    /** Callback for successful expire */
    onExpire: () => void;

    /** The device to expire */
    device: FullDevice;
};

/**
 * Dialog to expire the device key
 */
export default function ExpireDeviceKeyDialog(props: ExpireDeviceKeyDialogProps) {
    const [t] = useTranslation("dialog-expire-device-key");
    const [tg] = useTranslation();

    /**
     * Expire a device key
     */
    const expireKey = async () => {
        await ApiInternal.devices.expireDevice(props.device.uuid);
        toast.success(t("toast.key-expired-successfully"));
        props.onExpire();
    };

    return (
        <Dialog open={true} onClose={props.onClose}>
            <DialogTitle>{t("heading.expire-key", { device: props.device.dnsname })}</DialogTitle>
            <DialogDescription>{t("description.expire-key")}</DialogDescription>
            <DialogActions>
                <Button onClick={props.onClose}>{tg("button.cancel")}</Button>
                <Button color={"red"} onClick={async () => await expireKey()}>
                    {t("button.expire-key")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
